import {HTTP} from "../http"

export default {
    namespaced: true,

    state: {
        loading: false,
        user: null
    },

    mutations: {
        setUser(state, user) {
            state.user = user;
        },

        deleteUser(state) {
            state.user = null;
        },

        setLoading(state, loading) {
            state.loading = loading;
        }
    },

    actions: {
        login(context, login) {
            return HTTP.post('/auth/login', login)
                .then(resp => {
                    context.commit('setUser', resp.data);
                });
        },

        register(context, info) {
            return HTTP.post('/auth/register', info)
                .then(resp => context.commit('setUser', resp.data))
                .catch(err => context.commit('error/set', err.response.data, { root: true }));
        },

        logout(context) {
            return HTTP.post('/auth/logout')
                .then(resp => {
                    console.log('Logged out');
                    context.commit('deleteUser');
                });
        },

        getMe(context)  {
            context.commit('setLoading', true);

            return HTTP.get('/auth/me')
                .then(resp => {
                    context.commit('setUser', resp.data.user);
                    context.commit('setLoading', false);
                })
                .catch(err => context.commit('error/set', err.response.data, { root: true }));
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/auth.js